import React, { createContext, useContext, useState, useEffect } from "react";
import apiServiceInv from "../services/apiService";
import LeaseApiService from "../../PropertyManagement/services/apiService";

const CurrencyContext = createContext();

export const CurrencyProvider = ({ children }) => {
  const [currencyPrecision, setCurrencyPrecision] = useState(2);
  const [loading, setLoading] = useState(true);
  const apiService = new LeaseApiService();

  // ========== Fetch Currency Precision ==========
  const handleCurrencies = async () => {
    try {
      let body = {
        "take": 100,
        "skip": 0,
        "sortColumn": "id",
        "sortDirection": 1
      }
      const res = await apiService.post("GET_CURRENCY_PER", body);
      console.log("API Currency Response:", res?.data); // DEBUG
      let data = res?.data?.data?.items
      let defaultCurrency = data?.find((comp) => comp.isDefault === true)
      localStorage.setItem('currencylist', JSON.stringify(data));
      const precision = defaultCurrency?.decimalNumbers || 2;
      setCurrencyPrecision(defaultCurrency);
    } catch (error) {
      console.error("Failed to fetch currency precision:", error);
    } finally {
      setLoading(false);
    }
  };

  // ========== Load at app start + Auto-refresh ==========
  useEffect(() => {
    handleCurrencies(); // first time load
    // Auto-refresh every 30 sec (Finance → React sync)
    const interval = setInterval(() => {
      handleCurrencies();
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  return (
    <CurrencyContext.Provider
      value={{
        currencyPrecision,
        setCurrencyPrecision,
        loading,
      }}
    >
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => useContext(CurrencyContext);